module.exports = __webpack_public_path__ + "static/img/gzh_bg.4b39934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzh_bg.png
// module id = WAF5
// module chunks = 1